import { ImgBackgroundWrapper } from 'components/Common/CommonWrappers';
import { MainButton } from 'global-styles/MainButton';
import { txtAnimation } from 'components/Home/BannerItems';
import { NormalArrowIcon } from 'assets/icons';
import { H3, SubtitleM } from 'global-styles';
import { useContactModal } from 'hooks/useContactModal';
import Image from 'next/image';
import styled, { css } from 'styled-components';
import { generateCssStyle, mediaQueryStyle } from 'styles/breakPoints';
import { useInView } from 'react-intersection-observer';

interface Props {
  bannerImg: string;
  bannerText: string;
  bannerTitle: string;
  buttonText: string;
}

const ProductBanner = ({
  bannerImg,
  bannerText,
  bannerTitle,
  buttonText,
}: Props) => {
  const [targetRef, isVisible] = useInView({ fallbackInView: true });

  const { handleOpenContactModal } = useContactModal();
  return (
    <ProductBannerContainer ref={targetRef} isVisible={isVisible}>
      <ImgBackgroundWrapper>
        <Image
          src={bannerImg}
          layout="fill"
          className="target-img"
          objectFit="cover"
          loading="eager"
          quality={55}
          priority
          alt=""
          sizes="(min-width: 1400px) 1200px,
                 (min-width: 905px) calc(100vw - 60px), 
                 (min-width: 600px) 580px,
                 (max-width: 599px) 400px"
        />
      </ImgBackgroundWrapper>

      <div className="banner-inner-wrapper">
        <H3 className="banner-title">{bannerTitle}</H3>
        <SubtitleM className="banner-text">{bannerText}</SubtitleM>

        <MainButton
          className="p-b-btn"
          onClick={handleOpenContactModal}
          buttonType="default-w"
          text={buttonText}
          icon={<NormalArrowIcon />}
          injectInlineStyles={{ height: '48px', marginTop: '32px' }}
          injectCssStyles={[
            generateCssStyle({ width: '156px' }),
            mediaQueryStyle.M`width: 328px;`,
          ]}
        />
      </div>
    </ProductBannerContainer>
  );
};

export default ProductBanner;

const ProductBannerContainer = styled.article<{ isVisible: boolean }>`
  width: 100%;
  max-width: 1200px;
  position: relative;
  height: 380px;
  color: #fff;

  @media screen and (min-width: 1440px) {
    width: 100%;
    max-width: 1200px;
    margin: 96px auto 0;
  }
  @media screen and (min-width: 1240px) and (max-width: 1439px) {
    width: calc(100% - 192px);
    margin: 96px 96px 0;
  }
  @media screen and (min-width: 905px) and (max-width: 1239px) {
    width: calc(100% - 112px);
    margin: 96px 56px 0;
  }
  @media screen and (max-width: 904px) and (min-width: 600px) {
    margin: 56px 0 0;
  }
  @media screen and (max-width: 599px) {
    margin: 32px 0 0;
  }
  .banner-inner-wrapper {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 56px;
    word-break: break-word;
    .banner-text {
      width: 48ch;
      opacity: 0;
    }
    .banner-title {
      opacity: 0;
    }
    .p-b-btn {
      opacity: 0;
    }
    ${({ isVisible }) =>
      isVisible &&
      css`
        .banner-title {
          animation: ${txtAnimation} 1s cubic-bezier(0.4, 0, 0.2, 1) backwards;
          opacity: 1;
        }
        .banner-text {
          animation: ${txtAnimation} 1s 0.3s cubic-bezier(0.4, 0, 0.2, 1)
            backwards;
          opacity: 1;
        }
        .p-b-btn {
          animation: ${txtAnimation} 1s 0.8s cubic-bezier(0.4, 0, 0.2, 1)
            backwards;
          opacity: 1;
        }
      `};
    @media screen and (max-width: 904px) {
      padding: 0 32px;
      .banner-more-btn {
        width: 156px;
      }
    }
    @media screen and (max-width: 599px) {
      .banner-text {
        max-width: 35ch;
      }
    }
  }
`;
